import httpUtil from './httpUtil'


/**
 * 二维码注册
 * @param params
 * @returns {Promise<AxiosResponse<*>>}
 */
function registerQrCode(params){
    return httpUtil.post('/api/user/register/email/1',params);
}

/**
 * 生成支付链接
 * @param params
 * @returns {Promise<AxiosResponse<*>>}
 */
function createPayUrl(params){
    return httpUtil.post('/api/pay/order/create',params);
}

/**
 * 进行支付订单capture
 * @param params
 * @returns {Promise<AxiosResponse<*>>}
 */
function capturePayOrder(params){
    return httpUtil.post('/api/pay/order/capture',params);
}

/**
 * 验证apiKey是否合规，同时返回apiKey的过期时间等信息
 * @param params
 * @returns {Promise<AxiosResponse<*>>}
 */
function validateApiKey(params){
    return httpUtil.post('/api/key/query',params);
}

/**
 * 获取商品价格列表
 * @param params
 * @returns {Promise<AxiosResponse<*>>}
 */
function getProductList(params){
    return httpUtil.post('/api/product/get',params);
}

/**
 * 生成short url
 * @param params
 * @returns {Promise<AxiosResponse<*>>}
 */
function createShortUrl(params){
    return httpUtil.post('/api/shorturl/create',params);
}

export default {registerQrCode,createPayUrl,capturePayOrder,validateApiKey,getProductList,createShortUrl}
